import type { SurfaceCopy } from './surfaceTypes'

export const surfacePl: SurfaceCopy = {
  pages: {
    continueLearning: 'Kontynuuj naukę',
    keepLearning: 'Ucz się dalej',
    practice: 'Ćwiczenia',
    practiceSubtitle: 'Jednorazowe historie i ćwiczenia — tekst, który zostanie w bibliotece, twórz w Czytaniu.',
    settings: 'Ustawienia',
    settingsSubtitle: 'Konto i preferencje',
  },
  actions: {
    startReading: 'Zacznij czytać',
    browseReading: 'Znajdź coś do czytania',
    startRefresh: 'Zacznij powtórki',
    addWords: 'Dodaj słowa',
    startPractice: 'Zacznij ćwiczenia',
    cancel: 'Anuluj',
    saved: 'Zapisano',
    readyToRefresh: 'Gotowe do powtórki: {count} słów',
    readyToRefreshOne: 'Gotowe do powtórki: 1 słowo',
  },
  coach: {
    title: 'Notatka od coacha',
    dismiss: 'Ukryj',
    andWord: 'i',
    confusionCluster:
      'Często mylisz {words}. Krótki quiz pomoże je rozróżnić.',
    formGap:
      'Widziałeś «{surface}» {count} razy podczas czytania. {lemma} ma formy, których jeszcze nie spotkałeś{formsHint}.',
    formGapNoLemma:
      'Widziałeś «{surface}» {count} razy podczas czytania. Jego forma podstawowa ma formy, których jeszcze nie spotkałeś{formsHint}.',
    synonymMixup:
      '«{word1}» i «{word2}» znaczą podobne rzeczy — poćwiczmy ich rozróżnianie.',
    synonymMixupGeneric:
      'Te podobne słowa warto przejrzeć — pomoże krótki quiz.',
    neglectedWord:
      '{word} nie było w fokusie od {days} dni. Gotowy na krótką powtórkę?',
    neglectedWordGeneric:
      'To słowo nie było w fokusie od {days} dni. Gotowy na krótką powtórkę?',
    ctaPractice: 'Utwórz artykuł z tych słów',
    ctaOpenWord: 'Otwórz słowo',
    ctaChallenge: 'Zrób krótki quiz',
  },
  todayPlan: {
    heading: 'Twój dzień',
    refresh: 'Powtórki',
    newWords: 'Nowe słowa',
    reading: 'Czytanie',
    practice: 'Ćwiczenia AI',
    allCaughtUp: 'Na razie wszystko powtórzone',
  },
  dashboard: {
    loadFailed: 'Nie udało się wczytać Today',
    continueLearningEyebrow: 'Kontynuuj naukę',
    sessionLabelToday: 'Dzisiejsza sesja',
    sessionLabelComplete: 'Sesja na dziś zakończona',
    headlineResume: 'Wznów tam, gdzie skończyłeś',
    headlineReadyMore: 'Gotowy na więcej?',
    headlineWordsReady: '{count} słów gotowych do powtórki',
    headlineWordsReadyOne: '1 słowo gotowe do powtórki',
    headlineMinutesSession: 'Sesja ~{minutes} min',
    detailWaiting: 'Twoja sesja na Ciebie czeka.',
    detailDailyDone: 'Dzienny minimum za Tobą — eksploruj swobodnie.',
    detailWhatNext: 'Co chcesz zrobić dalej?',
    detailAboutMinutes: 'Około {minutes} min w Twoim planie na dziś.',
    detailCaughtUp: 'Jesteś na bieżąco — dalej może być krótkie czytanie.',
    guidedSessionMinutes: 'Sesja ~{minutes} min',
    startFailed: 'Nie udało się rozpocząć sesji. Spróbuj ponownie.',
    wordsThisMonth: '+{count} słów w tym miesiącu',
    totalInVocabulary: '{count} łącznie w słowniku',
    wordsRefreshedToday: 'Dziś powtórzono: {count} słów',
    wordsRefreshedTodayOne: 'Dziś powtórzono: 1 słowo',
    keepMomentum: 'Nie trać tempa',
    yesterdayMissed: 'Wczoraj ominąłeś „{word}” — dziś {correct} poprawnie',
    vocabHeading: 'Słownik',
    statusNew: 'Nowe',
    statusLearning: 'Uczę się',
    statusReview: 'Powtórka',
    statusMastered: 'Opanowane',
    dueForReview: 'Do powtórki',
    viewAllWords: 'Wszystkie słowa',
    streak: 'Seria',
    dayInARow: 'dzień z rzędu',
    daysInARow: 'dni z rzędu',
    studiedToday: '✓ Uczyłeś się dziś — tak trzymaj!',
    keepStreakAlive: 'Poćwicz dziś, żeby utrzymać serię.',
    startStreak: 'Zacznij się uczyć, żeby zbudować serię.',
    latestWin: 'Ostatnie osiągnięcie',
    catalogExploreHint: '— zajrzyj do bazy języka, gdy chcesz przeglądać',
    feedbackCta: 'Pomysł lub błąd? Napisz nam',
  },
  achievementTitles: {
    FIRST_SESSION: 'Pierwsze kroki',
    WEEK_STREAK: 'Tygodniowy wojownik',
    WORDS_50: 'Kolekcjoner słów',
    WORDS_100: 'Rosnący leksykon',
    WORDS_250: 'Budowniczy słownika',
    WORDS_500: 'Skarbiec słów',
    READING_STREAK_5: 'Rytm czytania',
    COMEBACK: 'Witaj z powrotem',
    FIRST_MASTERED: 'Pierwsze opanowanie',
    CHALLENGE_PERFECT: 'As wyzwania',
  },
  aiCredits: {
    heading: 'Dzienne kredyty AI',
    short: 'AI na dziś',
    ofLimit: '{used} użyto · limit {limit}',
    compact: 'Pozostało {remaining} z {limit} kredytów AI na dziś',
    hint: 'Na generowanie artykułów, praktykę i pytania do tekstu. Wyjaśnienia słów z cache są darmowe.',
    costPractice: 'Historia lub lekcja: {cost}',
    costArticle: 'Osobisty artykuł: {cost}',
    costComprehension: 'Pytania do przeczytanego: {cost}',
    costComprehensionCheck: 'Feedback trenera na odpowiedź: {cost}',
    reset: 'Reset o {time} (UTC). Zmiana strefy czasowej nie resetuje kredytów.',
    exceeded: 'Dzienne kredyty AI się skończyły. Reset o północy UTC.',
    phraseLimitExceeded: 'Dzienny limit wyjaśnień fraz wyczerpany. Już wyjaśnione frazy działają — spróbuj jutro.',
    phraseQuotaCompact: 'Pozostało {remaining} z {limit} nowych wyjaśnień fraz na dziś',
  },
  reading: {
    pickedForYou: 'Dla Ciebie',
    tabForYou: 'Dla Ciebie',
    tabLibrary: 'Biblioteka',
    noRecommendationTitle: 'Brak rekomendacji',
    noRecommendationHint: 'Otwórz bibliotekę albo wygeneruj artykuł ze swoich słów.',
    filterAll: 'Wszystkie',
    filterUnread: 'Nieprzeczytane',
    filterRead: 'Przeczytane',
    generatePersonalizedTitle: 'Artykuł z Twojego słownika',
    generatePersonalizedHint:
      'AI splata do {max} pozycji ze słownika w krótki osobisty tekst.',
    generatePersonalizedPrivate: 'Artykuł widzisz tylko Ty — nie jest udostępniany innym.',
    generatePersonalizedWordCount: '{count} z Twojego słownika',
    generatePersonalizedWordCountMax: 'Do {max} z Twojego słownika',
    shuffleWords: 'Przetasuj',
    generatePersonalizedNoWords: 'Zapisuj słowa podczas czytania, by odblokować osobiste artykuły.',
    generatePersonalizedCta: 'Wygeneruj artykuł ze słownika',
    generatePersonalizedLoading: 'Piszę Twój artykuł…',
    generatePersonalizedFailed: 'Nie udało się wygenerować artykułu. Spróbuj ponownie.',
    generatePersonalizedFieldLevel: 'Poziom',
    generatePersonalizedFieldDuration: 'Czas czytania',
    generatePersonalizedFieldTopics: 'Tematy',
    generatePersonalizedTopicsHint:
      'Wybierz do 2 tematów. Zostaw puste — weźmiemy z ustawień.',
    durationMinutes: '{minutes} min',
    durationMinutesApprox: '~{minutes} min',
    articleGeneratedTitle: 'Artykuł zapisany w Bibliotece',
    articleGeneratedBody: 'Osobisty artykuł jest gotowy. Znajdziesz go zawsze w zakładce Biblioteka.',
    articleGeneratedStart: 'Zacznij czytać',
    articleGeneratedLibrary: 'Do biblioteki',
    levelBadge: 'Poziom {level}',
    minRead: '{minutes} min czytania',
  },
  recommendation: {
    whyArticle: 'Dlaczego ten artykuł?',
    dueWords: 'Słowa do powtórki',
  },
  learn: {
    stepOf: 'Krok {current} z {total}',
    readPrefix: 'Czytaj:',
    readThenFinish: 'Przeczytaj artykuł i oznacz „Finished reading”, aby kontynuować sesję.',
    nothingScheduled: 'Na dziś nic nie zaplanowano',
    startRefresh: 'Zacznij powtórki',
    startChallenge: 'Zacznij sprawdzenie',
    backToToday: 'Wróć do „Dziś”',
  },
  practice: {
    generateStory: 'Wygeneruj historię',
    generateLesson: 'Wygeneruj lekcję',
    newLesson: 'Nowa lekcja',
    storyDesc: 'Krótka historia ze słów z Twojego słownika',
    lessonDesc: 'Interaktywna lekcja: rozgrzewka, ćwiczenia i wyzwanie',
    selectToStart: 'Wybierz słowa, aby zacząć.',
    wordLimit: '{selected} / {max}',
    wordLimitHint: 'Do {max} pozycji na historię lub lekcję (zależnie od poziomu)',
    wordLimitReached: 'Maksimum {max} — odznacz jedno, by dodać inne',
    pickRandom: 'Wybierz {count} losowych',
    pickWords: 'Wybierz słowa do ćwiczeń',
    deselectAll: 'Odznacz wszystko',
    articleTipTitle: 'Chcesz tekst, który zostanie?',
    articleTipBody:
      'Wygeneruj spersonalizowany artykuł w Czytaniu — zostanie w bibliotece i możesz klikać słowa w tekście.',
    articleTipCta: 'Przejdź do Czytania',
  },
  settingsChrome: {
    tabPreferences: 'Preferencje',
    tabAppearance: 'Wygląd',
    tabGoals: 'Cele dnia',
    tabNotifications: 'Powiadomienia',
    tabFeedback: 'Feedback',
    tabSecurity: 'Bezpieczeństwo',
    tabAccount: 'Konto',
    preferencesTitle: 'Preferencje',
    preferencesDescription: 'Język, poziom i ustawienia nauki.',
    savePreferences: 'Zapisz',
    goalsTitle: 'Codzienne cele',
    goalsDescription: 'Ustaw cele suwakami lub dokładnymi liczbami.',
    goalsNewWords: 'Nowe słowa dziennie',
    goalsReviews: 'Powtórki dziennie',
    goalsArticles: 'Artykuły dziennie',
    goalsPractice: 'Ćwiczenia AI dziennie',
    goalsPracticeProHint:
      'Ćwiczenia AI są w Pro. Cel zostanie zapisany i zadziała po upgrade.',
    goalsPracticeOff: 'Wył.',
    saveGoals: 'Zapisz cele',
    notificationsTitle: 'Powiadomienia',
    notificationsDescription: 'Email i przypomnienia.',
    notificationsComingSoon: 'Wkrótce',
    notificationsComingSoonHint:
      'Tygodniowy digest jest w przygotowaniu. Włączymy przełącznik, gdy dostawa będzie gotowa.',
    preferredTopics: 'Tematy, które lubisz',
    preferredTopicsHint: 'Używane do rekomendacji artykułów',
    includeQuickChallenge: 'Szybkie sprawdzenie w sesji guided',
    includeQuickChallengeHint: 'Dodaje krótki test słownictwa do codziennej sesji',
    defaultReviewMode: 'Domyślny tryb powtórek',
    defaultReviewModeHint: 'Używany przy osobnej sesji powtórek',
    targetLevel: 'Docelowy poziom angielskiego',
    targetLevelHint: 'Artykuły i ćwiczenia dopasujemy do tego poziomu.',
    sessionLength: 'Długość sesji guided',
    sessionLengthLabel: 'Długość sesji guided: {minutes} min',
    timezone: 'Strefa czasowa',
    timezoneHint: 'Ustawiona przy rejestracji. Dzienne limity AI resetują się o północy UTC.',
    securitySignOutTitle: 'Wyloguj',
    securitySignOutHint: 'Wyloguj się z Lexio na tym urządzeniu.',
    changePasswordTitle: 'Zmień hasło',
    changePasswordDescription: 'Zaktualizuj hasło do logowania.',
    accountTitle: 'Konto',
    accountDescription: 'Zarządzaj danymi konta.',
    backToSettings: 'Wróć do ustawień',
    goBack: 'Wstecz',
    loadFailed: 'Nie udało się wczytać ustawień',
  },
}
